import { ValidationError } from 'yup';
import { Slot } from './slot';

export class FuUnit {
    id: string;
    fcuId: string;
    vesselId: string;
    location: string;
    index: number;
    communicationType: CommunicationType;
    fieldNetLineAIp: string;
    fieldNetLineBIp: string;
}

export type FuUnitPayload = {
    id?: string;
    fcuId: string;
    vesselId: string;
    location: string;
    index: number;
    communicationType: CommunicationType;
    fieldNetLineAIp: string;
    fieldNetLineBIp: string;
};

export type FuUnitWithUX = FuUnit & {
    slotList: Slot[];
    validationErrors?: { [propertyName: string]: ValidationError | { message: string } };
};

export const communicationTypes = {
    serial: 'Serial',
    lan: 'LAN',
} as const;

export type CommunicationType = (typeof communicationTypes)[keyof typeof communicationTypes];

export const fuMax = 20;
